import React, { createContext, useEffect, useState } from "react";

export const userContext = createContext();

export default function Context({ children }) {
  //Authentication state
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  //User state
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    id: "",
    partnerId: "",
    role: "",
  });

  //Function to check if token is expired
  //Currently does not check between page renders, only on
  //page refresh.
  function isTokenExpired(token) {
    const expiry = JSON.parse(atob(token.split(".")[1])).exp;
    return Math.floor(new Date().getTime() / 1000) >= expiry;
  }

  useEffect(() => {
    if (!isAuthenticated) {
      let store = JSON.parse(localStorage.getItem("login"));
      if (store && store.token) {
        if (isTokenExpired(store.token)) {
          setIsAuthenticated(false);
          localStorage.removeItem("login");
        } else {
          setIsAuthenticated(true);
          setUser({
            firstName: store.user.firstName,
            lastName: store.user.lastName,
            email: store.user.email,
            id: store.user.id,
            partnerId: store.user.partnerId,
            role: store.user.role,
          });
        }
      }
    }
  }, [isAuthenticated]);

  return (
    <>
      {
        <userContext.Provider
          value={{ isAuthenticated, setIsAuthenticated, user, setUser }}
        >
          {children}
        </userContext.Provider>
      }
    </>
  );
}
